import {
  getUUid,
  getDevice,
  getFormatDate,
  sdkLoadTime as sdlTime,
  getCookie,
  isWiki,
  getNavigatorLang,
  consoleLog
} from './utils';
import { setVersionForAppAnalyze } from './appAnalyzeUtils';
export const uuid = getUUid();

export const sdkLoadTime = sdlTime;

/**
 * uuid:会话唯一id
 * device:设备信息
 * productName:
 * version:
 * userId:
 * docId:
 * docName:
 */
export type Imatadata = {
  uuid: string;
  productName?: string;
  screenWidth: number;
  screenHeight: number;
  availHeight: number;
  availWidth: number;
  isWiki: boolean;
  version?: string;
  userId?: string;
  docId?: string;
  docName?: string;
  timeSdkLoad: number;
  fTimeSdkLoad: string;
  timeNvStart: number;
  fTimeNvStart: string;
  loggerV: string;
  url: string;
  orgUrl: string;
  domainId?: string;
  domainName?: string; //租户名称
  did: string; //由app分析sdk种下的设备id
  nvLang: string; // 浏览器默认语言
  nationalityCode?: string; // 用户信息里中的国际化code
  assetsPrefix?: string; // 用于区分静态资源入口（国内:buildLocal，海外:buildOversea）
  gotoSSO?: boolean; // 是否跳转SSO
  isUnload?: boolean; // 是否卸载
  ip_subnet?: string; // 子网
} & ReturnType<typeof getDevice>;

// TODO: 知识库路由变更后更新获取docId的方法
const regEx = /([s|d|k|p|t|m])\/home\/(.*)/;
const docRes = regEx.exec(location.pathname);
let docId = '';
if (docRes) {
  if (docRes[1] === 'k' || docRes[1] === 't') {
    docId = docRes[2].split('/')[1];
  } else {
    docId = docRes[2];
  }
}

export function getDocId() {
  return docId;
}

const { width, height, availHeight, availWidth } = screen;

const nvStart = window.performance.timing.navigationStart;

const metaData: Imatadata = {
  screenWidth: width,
  screenHeight: height,
  availHeight: availHeight,
  availWidth: availWidth,
  isWiki,
  timeSdkLoad: sdkLoadTime,
  fTimeSdkLoad: getFormatDate(new Date(sdkLoadTime)),
  timeNvStart: nvStart,
  fTimeNvStart: getFormatDate(new Date(nvStart)),
  loggerV: process.env.CURRENT_VERSION || 'local',
  ...getDevice(),
  uuid,
  docId,
  orgUrl: location.href.replace('https://docs.corp.kuaishou.com', ''),
  url: location.href.replace('https://docs.corp.kuaishou.com', ''),
  did: getCookie('_did'),
  nvLang: getNavigatorLang(),
  assetsPrefix: '',
  gotoSSO: false,
  isUnload: false,
  ip_subnet: getCookie('ip_subnet')
};

export function setUserId(userId: string) {
  metaData.userId = userId;
}

export function getUserId() {
  return metaData.userId;
}

export function setProductName(productName: string) {
  metaData.productName = productName;
}

export function getProductName() {
  return metaData.productName;
}

export function setDomain(domainId: string, domainName: string) {
  metaData.domainId = domainId;
  metaData.domainName = domainName;
}

export function setVersion(version: string) {
  metaData.version = version;
  setVersionForAppAnalyze(version);
  consoleLog('BuildId:', version);
}

export function setDocId(docId: string) {
  metaData.docId = docId;
}

export function setDocName(docName: string) {
  metaData.docName = docName;
}

/**
 * 随意扩展meta
 * @param extraMeta
 */
export function extendMeta(extraM: { [metaKey: string]: any }) {
  Object.assign(metaData, extraM);
}

export default metaData;

export function getMetadata() {
  return metaData;
}
